import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {User} from '../model/index';

@Injectable()
export class UserService {
    constructor(private http: Http) {
    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('users?' + params.toString()).map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('users/' + _id).map((response: Response) => response.json());
    }

    hasTask() {
        return this.http.get('user/task').map((response: Response) => response.json());
    }

    getAllUsers(branch_id:string = null, department_id:string = null) {
        return this.http.get('users/all/' + branch_id + '/' + department_id).map((response: Response) => response.json());
    }

    getRoles() {
        return this.http.get('roles/all').map((response: Response) => response.json());
    }

    getUserBranDep(branch_id:string) {
        return this.http.get('user/branch/departments/' + branch_id).map((response: Response) => response.json());
    }

    getDepartmentUsers(department_id:string) {
        return this.http.get('department/users/' + department_id).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('users/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('users/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(user: User) {
        return this.http.post('users', user).map((response: Response) => response.json());
    }

    update(user: User) {
        return this.http.put('users/' + user.id, user).map((response: Response) => response.json());
    }
    updateProfile(user: User) {
        return this.http.put('usersProfile/' + user.id, user).map((response: Response) => response.json());
    }
    updatePic(user: User) {
        return this.http.put('usersPic/' + user.id, user).map((response: Response) => response.json());
    }
    reset(user: User) {
        return this.http.post('resetMail', user).map((response: Response) => response.json());
    }
    checkPassword(user: User) {
        return this.http.put('users/changepassword/' + user.id, user).map((response: Response) => response.json());
    }
    assignNewPassword(user: User) {
        return this.http.post('users/assignNewPassword', user).map((response: Response) => response.json());
    }
    toFactorAuth(user: User) {
        return this.http.post('users/factorAuth', user).map((response: Response) => response.json());
    }
    resendAuth(id: string) {
        return this.http.put('users/resendAuth/' +id,{});
    }

    delete(_id: string) {
        return this.http.delete('users/' + _id).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('picture/delete/' + _id,{}).map((response: Response) => response.json());
    }

    allpermission() {
        return this.http.get('permissions/allscreens').map((response: Response) => response.json());
    }

    getMenu() {
      const system = localStorage.getItem('OpenSystem');

      return this.http.get('menu/'+system).map((response: Response) => response.json());
    }

    getSystem(_screen:string) {
      return this.http.get('screensystem/'+_screen).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts